import React from "react";

import { Button } from "@mui/material";

import {
  Home,
  Tv,
  Trophy,
  Mail,
  ShieldCheck,
  Newspaper,
} from "lucide-react";
import { useSelector } from "react-redux";

import { NavLink } from "react-router-dom";

export default function MobileBottomNav() {
  const webSiteData = useSelector((state) => state.website) || {};

  const menus = [
    {
      label: "Home",
      icon: <Home size={20} />,
      link: "/",
    },

    {
      label: webSiteData?.sportName || "Sports",
      icon: <Tv size={20} />,
      link: "/channels",
    },

    // {
    //   label: "League",
    //   icon: <Trophy size={20} />,
    //   link: "/tournaments",
    // },

    {
      label: "News",
      icon: <Newspaper size={20} />,
      link: "/newses",
    },

    // {
    //   label: "DMCA",
    //   icon: <ShieldCheck size={20} />,
    //   link: "/dmca",
    // },
    // {
    //       label: "Contact Us",
    //       icon: <Mail size={18} />,
    //       link: "/contact",
    //     },
  ];

  return (
    <div
      className="
        md:hidden
        fixed
        bottom-0
        left-0
        w-full
        z-[999]
      "
    >
      <div
        className="
          bg-white
          dark:bg-[#111]
          border
          border-gray-200
          dark:border-gray-800
          shadow-2xl
          rounded-t-[0px]
          rounded-b-[0px]
          flex
          items-center
          justify-between
          py-2
          px-4
          backdrop-blur-xl
        "
      >
        {menus.map((item, index) => (
          <NavLink
            key={index}
            to={item.link}
            className={({ isActive }) =>
              `
              flex
              flex-col
              items-center
              justify-center
              rounded-2xl
              transition-all
              duration-300
              px-2
              py-1
              
              ${isActive
                ? "bg-orange-500 text-white shadow-lg"
                : "text-gray-600 dark:text-gray-300"
              }
            `
            }
          >
            <Button
              className="
                !min-w-[50px]
                !flex
                !flex-col
                !gap-1
                !capitalize
                !p-0
                !text-inherit
              "
            >
              {item.icon}

              <span className="text-[11px] font-medium">
                {item.label}
              </span>
            </Button>
          </NavLink>
        ))}
      </div>
    </div>
  );
}